/*
import "./aptumistic/accordion";
import "./aptumistic/mega-menu";
import "./aptumistic/slick";
import "./aptumistic/gravityforms";
import "./aptumistic/modal";
import "./aptumistic/matchHeight";
*/
import "./aptumistic/content-accordion";
import "./aptumistic/menu";
import "./aptumistic/drilldown";
import "./aptumistic/responsive-background-image";
import "./aptumistic/read-more";
import "./aptumistic/tabs";
import "./aptumistic/isotope";
import "./aptumistic/glide";
import "./aptumistic/slider-range";
import "./aptumistic/ui-tabs";
import "./aptumistic/ui-accordion";
import "./aptumistic/fancybox";
import "./aptumistic/sticky";
import "./aptumistic/wp-advanced-search";
import "./aptumistic/ui-autocomplete";
